import { Typography } from "antd";
import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import { numberFormater } from "../../utils";
import PropTypes from "prop-types";

const { Text } = Typography;

const reportFields = [
  { label: "Report Generation Date", value: "reportGenerationDate" },
  { label: "Monthly Cycle Selected", value: "monthlyCycleSelected" },
  { label: "Site Name", value: "site" },
  { label: "Site Address", value: "siteAddress1" },
  { label: "", value: "siteAddress2" },
  { label: "Meter ID", value: "device" },
  { label: "Installed Area", value: "installedArea" },
  { label: "Water Tariff Category", value: "tariffName" },
];

const WaterReportBody = ({ reportValues = {} }) => {
  return (
    <div className="p-4">
      <Row xs={1} md={2}>
        {/* Report Information */}
        <Col>
          <h5 className="mb-4 fw-bold">Report Information</h5>
          {reportFields.map((field, index) => (
            <Row key={index} xs={1} md={2} className="align-items-center">
              <Col className="my-2 flex justify-between">
                <Text>{field.label}</Text>
              </Col>
              <Col className="my-2 flex justify-between">
                <p className="bg-gray-300 px-2 py-1 w-100 rounded-2 mb-0" style={{ minHeight: 30 }}>
                  {reportValues[field?.value] || ""}
                </p>
              </Col>
            </Row>
          ))}
        </Col>

        {/* Water Usage Information */}
        <Col>
          <h5 className="mb-4 fw-bold">Water Usage Information</h5>

          {/* Table 1: Water Usage Breakdown */}
          <Table bordered responsive className="mt-1">
            <thead className="text-white text-center">
              <tr>
                <th style={{ background: "#184C78" }} className="text-white" colSpan={2}>
                  Water Usage Breakdown
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-3">Total Water Usage (m³)</td>
                <td className="px-3 text-end">{numberFormater(reportValues?.totalUsageM3 || 0)}</td>
              </tr>
            </tbody>
          </Table>

          {/* Table 2: Water Bill Cost Breakdown */}
          <Table bordered responsive className="mt-4">
            <thead className="text-white text-center">
              <tr>
                <th style={{ background: "#184C78" }} className="text-white" colSpan={2}>
                  Water Bill Cost Breakdown
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-3">Water Usage Charge (RM)</td>
                <td className="px-3 text-end">{numberFormater(reportValues?.waterUsageCharge || 0)}</td>
              </tr>
              <tr>
                <td className="px-3">Minimum Charge (RM)</td>
                <td className="px-3 text-end">{numberFormater(reportValues?.minimumCharge || 0)}</td>
              </tr>
              <tr>
                <td className="px-3">Service Tax ({reportValues?.type ?? "0"}%)</td>
                <td className="px-3 text-end">{numberFormater(reportValues?.serviceTax || 0)}</td>
              </tr>
              <tr className="fw-bold">
                <td className="px-3">Total Charge (RM)</td>
                <td className="px-3 text-end">{numberFormater(reportValues?.totalCharge || 0)}</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

WaterReportBody.propTypes = {
  reportValues: PropTypes.object,
};

export default WaterReportBody;
